<input
        #inputRef
        matInput
        ssFormInput
        [matDatepicker]="datePickerRef"
        (click)="datePickerRef.open()"        
/>
<mat-datepicker [startAt]="minSubject | async"  #datePickerRef></mat-datepicker>
